import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { UnsavedChangesDialogProps } from '../utils/DataTypes';

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({ open, onCancel, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="unsaved-changes-dialog-title">
      <DialogTitle id="unsaved-changes-dialog-title">Unsaved Changes</DialogTitle>
      <DialogContent>
        <Typography>
          You have unsaved changes that will be lost. Are you sure you want to discard them and continue?
        </Typography>
      </DialogContent>
      <DialogActions>
        {/* Wire buttons to the functions passed in as props */}
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
          Discard Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
